import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'
import _, { get } from 'lodash'
import styled from 'styled-components'

export default class Modal extends React.Component {
  render() {
    return (
      <ModalDiv>
        <Alert
          color={ get(this.props, 'type') === 200 ? "success" : "danger" }
          isOpen={ _.get(this.props, 'show') }
          toggle={ this.props.hide }
          style={ { color: get(this.props, 'fontColor') } }
        >
          { _.get(this.props, 'message') }
        </Alert>
      </ModalDiv>
    )
  }
}

Modal.propTypes = {
  hide: PropTypes.func.isRequired,
  // status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // message: PropTypes.string.isRequired,
}
const ModalDiv = styled.div`
  font-family: 'Gotham';
    font-size: 14px ;
`



// WEBPACK FOOTER //
// ./src/components/modal/index.js